import React from 'react';
import { 
  getReadableAuthorisationStatus, 
  getReadableOrganisationType 
} from '../../utils/sraMappers';

const AboutTab = ({ organisation }) => {
  // Parse practice_areas if it's a string
  const practiceAreas = typeof organisation.practice_areas === 'string' 
    ? JSON.parse(organisation.practice_areas)
    : (organisation.practice_areas || []);

  return (
    <div className="space-y-6">
      {/* <div>
        <h3 className="text-lg font-semibold mb-2">About Us</h3>
        <p className="text-gray-600">{organisation.about_text || 'No information available.'}</p>
      </div> */}
      <div>
        <h3 className="text-lg font-semibold mb-2">Practice Areas</h3>
        <div className="flex flex-wrap gap-2">
          {practiceAreas.length > 0 ? (
            practiceAreas.map(area => (
              <span
                key={area.id}
                className="organisation-page__tag"
              >
                {area.name}
              </span>
            ))
          ) : (
            <span className="organisation-page__tag">
              General
            </span>
          )}
        </div>
      </div>
      <div>
        <h3 className="text-lg font-semibold mb-2">Details</h3>
        <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {organisation.authorisation_status && (
            <div>
              <dt className="text-sm font-medium text-gray-500">Authorisation Status</dt>
              <dd className="text-gray-900">
              {getReadableAuthorisationStatus(organisation.authorisation_status)}
              </dd>
            </div>
          )}
          {organisation.organisation_type && (
            <div>
              <dt className="text-sm font-medium text-gray-500">Organisation Type</dt>
              <dd className="text-gray-900">
                {getReadableOrganisationType(organisation.organisation_type)}
              </dd>
            </div>
          )}
          {organisation.no_of_offices && (
            <div>
              <dt className="text-sm font-medium text-gray-500">Number of Offices</dt>
              <dd className="text-gray-900">{organisation.no_of_offices}</dd>
            </div>
          )}
          {organisation.company_reg_no && (
            <div>
              <dt className="text-sm font-medium text-gray-500">Company Registration</dt>
              <dd className="text-gray-900">{organisation.company_reg_no}</dd>
            </div>
          )}
        </dl>
      </div>
    </div>
  );
};

export default AboutTab; 